<section class="cz-equipment-dialog-component">
  <mat-dialog-title class="mat-dialog-title">
    <div class="row">
      <div class="col-xs-10">
        <h3 class="title" *ngIf="editInstalledEquipment">{{'$employee_equipment_edit_installed_label' | translate}} | {{ workflow.equipmentItem.title }}</h3>
        <h3 class="title" *ngIf="editRecommendedEquipment">{{'$employee_equipment_edit_recommended_label' | translate}} | {{ workflow.equipmentItem.title }}</h3>
        <h3 class="title" *ngIf="addInstalledEquipment">{{'$employee_equipment_add_installed_label' | translate}}</h3>
        <h3 class="title" *ngIf="addRecommendedEquipment">{{'$employee_equipment_add_recommened_label' | translate}}</h3>
      </div>
      <div class="col-xs-2 end-xs">
        <button mat-button mat-dialog-close class="mat-dialog-back-button">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </mat-dialog-title>
  <mat-dialog-content *ngIf="!equipmentAvailable">
    <p [innerHTML]="'$evaluation_equipment_none_available' | translate"></p>
  </mat-dialog-content>
  <mat-dialog-content *ngIf="equipmentAvailable">
    <!-- Common -->
    <div class="row" [formGroup]="categoryItemFormGroup">
      <div class="col-xs-6">
        <mat-form-field class="form-field form-full-width-field">
          <mat-label [innerHTML]="'$equipment_config_cat_label' | translate"></mat-label>
          <mat-select [formControl]="categoryControl" required>
            <mat-option *ngFor="let category of categoryList" [value]="category.id">{{category.title}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-xs-6">
        <mat-form-field class="form-field form-full-width-field">
          <mat-label [innerHTML]="'$equipment_config_item_label' | translate"></mat-label>
          <mat-select [formControl]="itemControl" required>
            <mat-option *ngFor="let item of categoryEquipmentList" [value]="item">{{item.title + (item.canRecommend ? ' (recommended list)' : '')}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row" [formGroup]="workAreaStatusFormGroup">
      <div class="col-xs-6">
        <mat-form-field class="form-field form-full-width-field">
          <mat-label [innerHTML]="'$employee_equipment_workarea_label' | translate"></mat-label>
          <mat-select [formControl]="workAreaControl" required>
            <mat-option *ngFor="let workArea of workAreas" [value]="workArea.id">{{workArea.label}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-xs-6">
        <mat-form-field class="form-field form-full-width-field">
          <mat-label [innerHTML]="'$employee_equipment_status_label' | translate"></mat-label>
          <mat-select [formControl]="statusControl" required>
            <mat-option *ngFor="let status of filteredStatusList" [value]="status.id">{{status.label}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-4">
        <figure class="equipment-image">
          <img src="{{workflow?.equipmentItem?.imageRef}}" />
        </figure>
      </div>
      <div class="col-xs-8">
        <div class="row">
          <div class="col-xs-6">
            <div class="value-only-field">
              <span class="label" [innerHTML]="'$equipment_config_manufacturer_label' | translate"></span>
              <span class="value">{{workflow?.equipmentItem?.manufacturer ? workflow?.equipmentItem?.manufacturer : 'N/A'}}</span>
            </div>
          </div>
          <div class="col-xs-6">
            <div class="value-only-field">
              <span class="label" [innerHTML]="'$equipment_config_model_label' | translate"></span>
              <span class="value">{{workflow?.equipmentItem?.modelNumber ? workflow?.equipmentItem?.modelNumber : 'N/A'}}</span>
            </div>
          </div>
        </div>
        <div class="row" [formGroup]="accessoryFieldsFormGroup">
          <div class="col-xs-6">
            <!-- Pending, Approved, Denied -->
            <mat-form-field class="form-field form-full-width-field">
              <mat-label [innerHTML]="'$equipment_config_color_label' | translate"></mat-label>
              <input matInput [value]="workflow?.equipmentItem?.color ? workflow?.equipmentItem?.color : ''"
                              formControlName="colorControl"/>
            </mat-form-field>
            <!-- Installed -->
            <mat-form-field class="form-field form-full-width-field">
              <mat-label [innerHTML]="'$employee_equipment_assetid_label' | translate"></mat-label>
              <input matInput [value]="workflow?.equipmentItem?.assetId"
                              formControlName="assetIdControl"/>
            </mat-form-field>
          </div>
          <div class="col-xs-6">
            <!-- Pending, Approved, Denied -->
            <mat-form-field class="form-field form-full-width-field">
              <input matInput [value]="workflow?.equipmentItem?.cost"
                              formControlName="costControl"
                              type="number"
                              placeholder="{{'$equipment_config_cost_label' | translate}}"
                              min="0"/>
              <span matPrefix>$&nbsp;</span>
            </mat-form-field>
            <!-- Installed -->
            <mat-form-field class="form-field form-full-width-field">
              <mat-label [innerHTML]="'$employee_equipment_serial_num_label' | translate"></mat-label>
              <input matInput [value]="workflow?.equipmentItem?.serialNumber"
                              formControlName="serialNumberControl"/>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-6">
            <!-- Pending, approved, denied, view installed -->
            <mat-form-field class="form-field form-full-width-field" *ngIf="fieldState">
              <mat-label *ngIf="fieldState === recommendedState" [innerHTML]="'$employee_equipment_recommended_date_label' | translate"></mat-label>
              <mat-label *ngIf="fieldState === installedState" [innerHTML]="'$employee_equipment_installed_date_label' | translate"></mat-label>
              <mat-label *ngIf="fieldState === removedState" [innerHTML]="'$employee_equipment_removed_date_label' | translate"></mat-label>
            <input matInput [matDatepicker]="picker"
                              [formControl]="statusDateControl" />
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-xs-6">
            <!-- Pending, Approved, Denied, View Installed -->
            <div class="value-only-field">
              <span class="label" *ngIf="fieldState === recommendedState" [innerHTML]="'$employee_equipment_recommended_by_label' | translate"></span>
              <span class="label" *ngIf="fieldState === installedState" [innerHTML]="'$employee_equipment_installed_by_label' | translate"></span>
              <span class="label" *ngIf="fieldState === removedState" [innerHTML]="'$employee_equipment_removed_by_label' | translate"></span>
              <cz-user-name-link [user]="currentStatusUser" *ngIf="currentStatusUser"></cz-user-name-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="value-only-field" *ngIf="workflow?.equipmentItem?.productUrl">
      <a target="_blank" href="{{workflow?.equipmentItem?.productUrl}}">{{'$employee_equipment_product_url_label' | translate}}</a>
    </div>
    <div class="value-only-field">
      <h5 [innerHTML]="'$common_description' | translate"></h5>
      <editor [apiKey]="tinyApiKey"
              [init]="descriptionDisplayConfig"
              [formControl]="descriptionControl"></editor>
    </div>

    <!-- Status Note -->
    <hr class="hr" />
    <div class="col-xs-12" *ngIf="currentStatus">
      <div class="value-only-field">
        <h5>{{currentStatus?.statusTypeLabel}} {{'$employee_equipment_status_note_label' | translate}}  {{currentStatus?.createdBy?.displayName != null? ' | '+currentStatus?.createdBy?.displayName + ' | ':''}} {{currentStatus?.createdDate | date:'MM-dd-yyy'}}</h5>
        <p>
          <editor [formControl]="statusNoteControl" 
                  [apiKey]="tinyApiKey"
                  [init]="editorConfig"></editor>
        </p>
      </div>
    </div>

    <!-- Status History -->
    <div class="status-history" *ngIf="statusHistory && statusHistory.length > 0">
      <h5 [innerHTML]="'$employee_equipment_status_history_label' | translate"></h5>
      <mat-accordion class="status-history-panels" multi="true">
        <mat-expansion-panel *ngFor="let status of statusHistory">
          <mat-expansion-panel-header>
            <mat-panel-title class="truncate">
              {{status.statusTypeLabel}}
            </mat-panel-title>
            <mat-panel-description>
              {{status.createdBy.displayName}} | {{status.createdDate | date:'MM-dd-yyyy'}}
            </mat-panel-description>
          </mat-expansion-panel-header>
          <!-- Note here -->
          <div [innerHtml]="getStatusDescription(status)">
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </mat-dialog-content>
  <mat-actions class="bottom-actions">
    <div class="row">
      <div class="col-xs">
        <button mat-stroked-button color="accent" mat-dialog-close [innerHTML]="'$equipment_config_cancel_btn' | translate"></button>
        <button mat-button color="error" class="btn-delete" *ngIf="statusHistory && statusHistory.length === 0" (click)="deleteItem()" [innerHTML]="'$equipment_config_delete_btn' | translate"></button>
      </div>
      <div class="col-xs end-xs" *ngIf="equipmentAvailable">
        <button mat-flat-button color="accent" (click)="saveWorkflow()" [innerHTML]="'$equipment_config_save_btn' | translate"></button>
      </div>
    </div>
  </mat-actions>
</section>
